export default "images/组 52.png";